import { AppointmentTerm } from "@tellescope/types-models";
import { Button, Input } from "@tellescope/ui";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface TermConfigRowProps {
  term: AppointmentTerm;
  onTermChange: (term: AppointmentTerm) => void;
  onDelete: () => void;
}

export const TermConfigRow = ({ term, onTermChange, onDelete }: TermConfigRowProps) => {
  const { t } = useTranslation("calendar");

  return (
    <div className="border rounded-md p-3 gap-1 grid grid-cols-[1fr_1fr_min-content] items-center">
      <Input
        value={term.title}
        onChange={(e) =>
          onTermChange({
            ...term,
            title: e.target.value,
          })
        }
        className="bg-gray-100 border-0 text-muted-foreground font-light text-xs md:text-xs"
        placeholder={t("Title e.g., Privacy Policy, Terms of Service")}
      />
      <Input
        value={term.link}
        onChange={(e) =>
          onTermChange({
            ...term,
            link: e.target.value,
          })
        }
        className="bg-gray-100 border-0 text-muted-foreground font-light text-xs md:text-xs"
        placeholder={t("https://example.com/terms")}
      />
      <Button
        variant="ghost"
        onClick={onDelete}
        size="sm-icon"
        className="text-muted-foreground hover:text-destructive hover:bg-destructive/10"
      >
        <Trash2 />
      </Button>
    </div>
  );
};
